import UserError from '@/error';
import { logger } from '@/logger';
import { useConfigStore } from '@/stores/config';
import axios, { AxiosError, AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    skipInterceptorResponse?: boolean;
  }
}

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

// 요청 인터셉터 추가하기
instance.interceptors.request.use(
  (axiosConfig: InternalAxiosRequestConfig) => {
    axiosConfig.timeout = 30 * 1000;
    const configStore = useConfigStore();
    if (configStore.config) {
      if (!axiosConfig.headers) axiosConfig.headers = {} as AxiosRequestHeaders;
      axiosConfig.headers.CompanyID = axiosConfig.headers.CompanyID || configStore.config.StoreID;
      axiosConfig.headers.StoreCode = axiosConfig.headers.StoreCode || configStore.config.SubStoreCode;
      axiosConfig.headers.POSID = axiosConfig.headers.POSID || configStore.config.PosCode || '';
    }
    return axiosConfig;
  },
  (error: unknown) => {
    // 요청 오류가 있는 작업 수행
    return Promise.reject(error);
  },
);

// 응답 인터셉터 추가하기
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    // 2xx 범위에 있는 상태 코드는 이 함수를 트리거 합니다.
    // 응답 데이터가 있는 작업 수행
    return response;
  },
  (error) => {
    const config = error.config as any;
    if (config?.skipInterceptorResponse) {
      // 해당 요청은 인터셉터 무시
      return Promise.reject(error);
    }
    // 2xx 외의 범위에 있는 상태 코드는 이 함수를 트리거 합니다.
    // 응답 오류가 있는 작업 수행

    if (error instanceof AxiosError) {
      if (error.response && error.response.status >= 500) {
        logger.error(error.response.data);
        throw new UserError('서버 에러가 발생하였습니다.');
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
